export default __webpack_public_path__ + "static/media/aboutbulb.7d32af20.png";